var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
import { RacingStore } from "../../data/store";
// external components
import * as CMP from "./components";
/*
    Setup testing tools for MobX
    uncoment the <DevTools /> at the end of the RacingRegionSwitcher component
*/
// import DevTools from "mobx-react-devtools";
// import { setLogEnabled, setUpdatesEnabled, setGraphEnabled } from "mobx-react-devtools";
// if (process.env.NODE_ENV === "development") {
//     setLogEnabled(true);
//     setUpdatesEnabled(true);
//     setGraphEnabled(true);
// }
let RacingRegionSwitcher = class RacingRegionSwitcher extends React.Component {
    /* istanbul ignore next */
    constructor(props) {
        super(props);
        /* istanbul ignore next */
        this.dict = this.props.dict;
        /* istanbul ignore next */
        this.state = {
            dataProvider: this.props.dataProvider,
            selected: 1
        };
        this.racingStore = RacingStore.getInstance;
    }
    /* istanbul ignore next */
    handleClick(value) {
        this.racingStore.setRegion(value);
    }
    /* istanbul ignore next */
    render() {
        return (React.createElement("div", { className: "racing-region-selector" }, this.state.dataProvider.regions.map((item) => {
            return React.createElement(CMP.Region, { key: item.name, label: item.name, selected: this.racingStore.regionId === item.id ? true : false, handler: () => this.handleClick(item.id) });
        })));
    }
};
RacingRegionSwitcher = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], RacingRegionSwitcher);
export { RacingRegionSwitcher };
//# sourceMappingURL=RacingRegionSwitcher.js.map